import { ReactNode } from "react";

interface TituloProps {
  titulo?: string,
  icon?: ReactNode,
}

export function TituloPagina({ icon, titulo } : TituloProps){
  return (
    <div className="flex flex-row gap-4 items-center">
      {icon}
      <h1 className="text-[3rem] font-[600]">{titulo}</h1>
    </div>
  );
}

export function Titulo({ icon, titulo } : TituloProps){
  return (
    <h2 className="text-[2rem] font-[500]">{titulo}</h2>
  );
}

export function Subtitulo({ icon, titulo } : TituloProps){
  return (
    <div className="flex flex-row gap-4 items-center">
      {icon}
      <h3 className="text-[1.5rem] font-[400]">{titulo}</h3>
    </div>
  );
}